export const infoBlockTheme = {
  blockTitle: 'palette.tertiary.90',
  detailsBlock: {
    bg: 'palette.surface.2',
    borderRadius: '12px',
  },
};
